module.exports = __webpack_public_path__ + "img/pencil-filter-left_cn.01723c2.jpg";